(function(){
    'use strict';
    angular.module('Directives').directive('bbaDriverChat', bbaDriverChat);
    bbaDriverChat.$inject = [];

    function bbaDriverChat(){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/driver-chat/bbaDriverChat.html',
            scope: {
                newMessageData: '='
            },
            link: bbaDriverChatLink
        }

        function bbaDriverChatLink(scope, elements, attrs){
            scope.chatHeads = [];
            scope.removeChatHeadCallback = removeChatHeadCallback; 
            scope.selectDriverCallback = selectDriverCallback;
            scope.selectJobCallback = selectJobCallback;
            scope.viewMessageCallback = viewMessageCallback; 

            init();
            function init(){    
                scope.$watch('newMessageData', function(newMessageData){
                    if(newMessageData != null) {
                        scope.newMessageData = newMessageData;
                        const storedNewMessages = JSON.parse(localStorage.getItem('new-messages')); 
                        if(storedNewMessages  == null) {
                            const newMsg = [];
                            newMsg[0] = newMessageData;
                            localStorage.setItem('new-messages', JSON.stringify(newMsg));
                        }
                        else {
                            storedNewMessages.push(newMessageData);
                            localStorage.setItem('new-messages', JSON.stringify(storedNewMessages));
                        }

                        playNotificationSounds();
                        
                    }
                });
            }

            function playNotificationSounds(){
                const notifSoundElem = angular.element(document.querySelector('#chat-notification-audio'));
                notifSoundElem[0].play();
            }

            function removeChatHeadCallback(data) {
                scope.chatHeads = scope.chatHeads.filter(chatHead => {
                    return chatHead.jobId != data.jobId;
                });
            }

            function selectDriverCallback(driver) {
                scope.selectedDriver = driver;
                const found = scope.chatHeads.filter(item=>{
                    return item.jobId == 'jobs-list';
                });
                if(found.length == 0) {
                    scope.chatHeads.unshift({
                        jobId: 'jobs-list'
                    });
                }
            }

            function selectJobCallback(job){
                const found = scope.chatHeads.filter(item=>{
                    return item.jobId == job.jobId; 
                });
                if(found.length == 0) {
                    scope.chatHeads.push(job);
                    if(scope.chatHeads.length > 7) {
                        scope.chatHeads.shift();
                    }
                }
            }

            function viewMessageCallback(msg){
                scope.updateNewMsgNotif = msg;
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/driver-chat/bbaDriverChat.js